import { EntityType } from 'clients/AzureMapClient';
import { postalCodes } from '../context/postalData';

export type Option = string | Record<string, any>;

export class AssistedAddressFilter {
  public static findPostalCodeOptions(selectedPostalCode: string) {
    const postalCodeOptions: any = postalCodes
      .map((elem) => {
        return {
          postalCode: elem.postalCode.toString(),
          municipality: elem.municipality.toString()
        };
      })
      .filter((elem) => elem.postalCode.startsWith(selectedPostalCode))
      .slice(0, 100);
    return postalCodeOptions;
  }

  public static findMunicipalityOptions(addresses: any, selectedPostalCode: string) {
    const geographyAddresses = this.filterGeographyAddresses(addresses);

    // Filter all candidates from geographyAddress
    const candidates = geographyAddresses.filter((res: any) => {
      if (selectedPostalCode.length === 0) return true; // Skip check if no postalcode is given

      return selectedPostalCode === res.address?.postalCode;
      // return res.address?.postalCode
      //   ? this.selectedOptions.postalCode.includes(res.address?.postalCode) ||
      //       this.formValues.postalCode.includes(res.address?.postalCode)
      //   : [];
    });

    return (
      candidates
        .map((municipalityObject: any) => {
          const freeformMunicipality =
            (municipalityObject.address?.freeformAddress.match(/\s(.*)/))[0];
          const municipality = {
            name: freeformMunicipality.trim(),
            parent: undefined
          };

          return [municipality];
        })
        .flat()
        .reduce((accumulator: any, current: any) => {
          if (!accumulator.find((item: any) => item.name === current.name)) {
            accumulator.push(current);
          }
          return accumulator;
        }, [])
        .filter(
          (postalCode: string, pos: any, self: string | any[]) => self.indexOf(postalCode) === pos // remove duplicate entries
        ) || ['']
    );
  }

  public static findStreetOptions(
    addresses: any,
    selectedPostalCode: string,
    selectedMunicipality: string
  ) {
    return this.filterStreetAddresses(addresses, selectedPostalCode)
      .filter((streetEntity: any) => streetEntity.address?.streetName !== '')
      .filter((res: any) => {
        return (
          [res.address?.municipality, res.address?.municipalitySubdivision].includes(
            selectedMunicipality
          ) || selectedPostalCode === res.address?.postalCode
        );
      })
      .map((res: any) => res.address?.streetName)
      .filter((res: any) => {
        return res !== undefined;
      });
  }

  public static findMunicipalityByPostalCode(postalCode: string) {
    const res = postalCodes
      .map((elem) => {
        return {
          postalCode: elem.postalCode.toString(),
          municipality: elem.municipality.toString()
        };
      })
      .filter((elem) => elem.postalCode === postalCode);

    return res;
  }

  private static filterMunicipalityAddresses(addresses: any) {
    return addresses.filter((address: any) => {
      return address.type === EntityType.Municipality;
    });
  }

  private static filterGeographyAddresses(addresses: any) {
    return addresses.filter(
      (address: any) =>
        address.type === EntityType.Geography && !address.address?.postalCode.includes(',') // ignore entries with streets between two municipalities
    );
  }

  private static filterStreetAddresses(addresses: any, selectedPostalCode: string) {
    return addresses.filter(
      (address: any) =>
        address.type === EntityType.Street &&
        address.address?.postalCode.includes(selectedPostalCode)
    );
  }
}
